import { createFileRoute } from '@tanstack/react-router'
import { NotesListPage } from '@/pages/Notes/NotesListPage'

export const Route = createFileRoute('/notes/')({
  component: NotesListPage,
  head: () => ({
    meta: [{ title: 'Notes — Enablar' }],
  }),
})
